<template>
    <div>
        <v-container fluid>

            <div class="main">
                <v-row justify="center">
                    <v-col cols="12" lg="8">

                        <v-card-title class="pl-0 pr-0">

                            <v-icon v-if="!id" color="primary" left>mdi-plus-circle</v-icon>
                            <v-icon v-if="id" color="primary" left>mdi-content-duplicate</v-icon>
                            <span v-if="!id"> Ajouter une campagne</span>
                            <span v-if="id"> Dupliquer une campagne</span>

                            <v-spacer/>

                            <v-btn color="primary" dark depressed fab small to="/campaigns">
                                <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>

                        </v-card-title>

                        <v-card :disabled="duplicateLoading"
                                :loading="duplicateLoading"
                                class="rounded-lg shadow">


                            <v-stepper v-model="step" flat>
                                <v-stepper-header class="elevation-0">
                                    <v-stepper-step :complete="step > 1" step="1">
                                        Info & Planification
                                    </v-stepper-step>

                                    <v-divider/>

                                    <v-stepper-step :complete="step > 2" step="2">
                                        BDD & Montant
                                    </v-stepper-step>

                                    <v-divider/>

                                    <v-stepper-step :complete="step > 3" step="3">
                                        SMS
                                    </v-stepper-step>

                                </v-stepper-header>

                                <v-divider/>

                                <v-stepper-items>

                                    <v-stepper-content step="1">
                                        <v-card>

                                            <v-card-text>

                                                <v-text-field v-model.trim="form.title"
                                                              :error-messages="errors.title"
                                                              label="Titre *"/>

                                                <v-row>
                                                    <v-col>
                                                        <v-menu
                                                                v-model="dateMenu"
                                                                :close-on-content-click="false"
                                                                :nudge-right="40"
                                                                min-width="auto"
                                                                offset-y
                                                                transition="scale-transition"
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-text-field
                                                                        v-model="form.scheduled_date"
                                                                        label="Date d'envoi *"
                                                                        prepend-inner-icon="mdi-calendar-outline"
                                                                        readonly
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker v-model="form.scheduled_date"
                                                                           :min="form.scheduled_date"
                                                                           @input="dateMenu = false"
                                                            ></v-date-picker>
                                                        </v-menu>
                                                    </v-col>
                                                    <v-col>
                                                        <v-menu
                                                                ref="menu"
                                                                v-model="timeMenu"
                                                                :close-on-content-click="false"
                                                                :nudge-right="40"
                                                                :return-value.sync="form.scheduled_time"
                                                                min-width="auto"
                                                                offset-y
                                                                transition="scale-transition"
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-text-field
                                                                        v-model="form.scheduled_time"
                                                                        label="Heur d'envoi *"
                                                                        prepend-inner-icon="mdi-clock-outline"
                                                                        readonly
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-time-picker v-model="form.scheduled_time"
                                                                           @click:minute="$refs.menu.save(form.scheduled_time)"
                                                            ></v-time-picker>
                                                        </v-menu>
                                                    </v-col>
                                                </v-row>

                                                <v-alert v-if="errors && errors.scheduled_datetime" dense type="error">
                                                    {{ errors.scheduled_datetime[0] }}
                                                </v-alert>

                                                <v-file-input ref="image"
                                                              :clearable="false"
                                                              :disabled="fileLoading"
                                                              :error-messages="fileErrors.image"
                                                              :loading="fileLoading"
                                                              :prepend-icon="null"
                                                              accept="image/*"
                                                              chips
                                                              counter
                                                              label="Sélectionnez une image à afficher sur l'application mobile"
                                                              show-size
                                                              small-chips
                                                              @change="handleUploadFile($event)"
                                                >
                                                    <v-icon slot="prepend-inner" color="gifty">
                                                        mdi-image
                                                    </v-icon>
                                                </v-file-input>

                                                <div v-if="form.image"
                                                     class="d-flex justify-space-between pa-3 rounded grey lighten-4">
                                                    <v-avatar size="40">
                                                        <v-img :src="fileUrl + form.image" class="rounded"/>
                                                    </v-avatar>
                                                    <v-spacer/>
                                                    <v-icon color="red" @click="resetImage()">mdi-close-circle
                                                    </v-icon>
                                                    <v-icon color="success">mdi-check-circle</v-icon>
                                                </div>

                                                <v-text-field v-model="form.youtube_link"
                                                              :error-messages="errors.youtube_link"
                                                              label="Entrez la clé vidéo youtube"
                                                              placeholder="Exemple : watch?v=(ThutMddh32E)">
                                                    <v-icon slot="prepend-inner" color="gifty">
                                                        mdi-youtube
                                                    </v-icon>
                                                </v-text-field>

                                                <v-alert border="left"
                                                         dense
                                                         prominent
                                                         text
                                                         type="info">
                                                                            <span class="font-weight-bold pointer">
                                                                              <Copy text="@person"/>
                                                                            </span>
                                                    Est remplacé par le nom de la personne
                                                </v-alert>


                                                <v-textarea v-model.trim="form.message"
                                                            :error-messages="errors.message"
                                                            clearable
                                                            label="Tapez ici un message qui affiche sur l'application mobile *"
                                                            outlined
                                                            prepend-inner-icon="mdi-message-outline"
                                                            rows="3">
                                                </v-textarea>

                                            </v-card-text>

                                            <v-card-actions>
                                                <v-spacer/>
                                                <v-btn :dark="!(!form.title || !form.message)"
                                                       :disabled="!form.title || !form.message"
                                                       color="primary"
                                                       depressed
                                                       @click="step = 2">
                                                    Continuer
                                                    <v-icon right>mdi-arrow-right</v-icon>
                                                </v-btn>
                                            </v-card-actions>

                                        </v-card>
                                    </v-stepper-content>

                                    <v-stepper-content step="2">
                                        <v-card>

                                            <v-card-text>

                                                <v-autocomplete v-model="form.database_id"
                                                                :disabled="isDBLoading"
                                                                :error-messages="errors.database_id"
                                                                :items="databases"
                                                                :loading="isDBLoading"
                                                                item-text="name"
                                                                item-value="id"
                                                                label="Sélectionnez une base de données *"
                                                />

                                                <v-radio-group v-model="form.amount_mode"
                                                               label="Montant à envoyer *"
                                                               row>
                                                    <v-radio label="Le même montant pour toute la base"
                                                             value="fixed"></v-radio>
                                                    <v-radio label="Un montant par numéro (fichier Excel)"
                                                             value="file"></v-radio>
                                                </v-radio-group>

                                                <v-text-field v-if="form.amount_mode === 'fixed'"
                                                              v-model.trim="form.amount"
                                                              v-number
                                                              :error-messages="errors.amount"
                                                              label="Montant *"
                                                              suffix="DZD"/>

                                                <div v-else>

                                                    <v-alert v-if="!form.database_id"
                                                             border="left"
                                                             dense
                                                             text
                                                             type="info">
                                                        Sélectionnez d'abord une base de données, les numéros du fichier
                                                        y seront recherchés.
                                                    </v-alert>

                                                    <v-file-input v-else
                                                                  ref="amountsFile"
                                                                  :clearable="false"
                                                                  :disabled="amountsLoading"
                                                                  :error-messages="errors.amounts_file"
                                                                  :loading="amountsLoading"
                                                                  :prepend-icon="null"
                                                                  accept=".xlsx,.xls,.csv"
                                                                  chips
                                                                  counter
                                                                  label="Fichier Excel : numéro + montant *"
                                                                  show-size
                                                                  small-chips
                                                                  @change="handleUploadAmounts($event)">
                                                        <v-icon slot="prepend-inner" color="gifty">
                                                            mdi-file-excel
                                                        </v-icon>
                                                    </v-file-input>

                                                    <div class="d-flex align-center mb-3">
                                                        <v-btn class="text-none"
                                                               color="primary"
                                                               small
                                                               text
                                                               @click="downloadTemplate">
                                                            <v-icon left small>mdi-download</v-icon>
                                                            Télécharger un modèle
                                                        </v-btn>
                                                        <v-spacer/>
                                                        <v-btn v-if="amountsPreview"
                                                               class="text-none"
                                                               color="red"
                                                               small
                                                               text
                                                               @click="resetAmountsFile">
                                                            <v-icon left small>mdi-close-circle</v-icon>
                                                            Retirer le fichier
                                                        </v-btn>
                                                    </div>

                                                    <v-card v-if="amountsPreview" class="mb-3" outlined>
                                                        <v-card-text>

                                                            <v-row>
                                                                <v-col cols="6" sm="4">
                                                                    <div class="caption grey--text">Transferts</div>
                                                                    <div class="font-weight-bold">
                                                                        {{ amountsPreview.summary.recipients_count }}
                                                                        / {{ amountsPreview.summary.rows_total }}
                                                                    </div>
                                                                </v-col>
                                                                <v-col cols="6" sm="4">
                                                                    <div class="caption grey--text">Numéros distincts
                                                                    </div>
                                                                    <div class="font-weight-bold">
                                                                        {{ amountsPreview.summary.salepoints_count }}
                                                                    </div>
                                                                </v-col>
                                                                <v-col cols="12" sm="4">
                                                                    <div class="caption grey--text">Montant total</div>
                                                                    <div class="font-weight-bold gifty--text">
                                                                        {{
                                                                            CurrencyFormatting(amountsPreview.summary.amount_total)
                                                                        }} DZD
                                                                    </div>
                                                                </v-col>
                                                            </v-row>

                                                            <v-alert v-if="amountsPreview.summary.rejected_count"
                                                                     class="mb-0 mt-3"
                                                                     dense
                                                                     text
                                                                     type="warning">
                                                                {{ amountsPreview.summary.rejected_count }} ligne(s)
                                                                ignorée(s) :
                                                                {{ amountsPreview.summary.not_found_count }} introuvable(s),
                                                                {{ amountsPreview.summary.invalid_count }} invalide(s).
                                                            </v-alert>

                                                            <v-alert v-if="amountsPreview.summary.duplicated_count"
                                                                     class="mb-0 mt-3"
                                                                     dense
                                                                     text
                                                                     type="info">
                                                                {{ amountsPreview.summary.duplicated_count }} ligne(s)
                                                                concernent un numéro déjà présent : un transfert
                                                                séparé est créé pour chacune, avec un seul SMS par
                                                                numéro.
                                                            </v-alert>

                                                            <div v-if="amountsPreview.errors.length"
                                                                 class="text-right">
                                                                <v-btn class="text-none"
                                                                       small
                                                                       text
                                                                       @click="showRejected = !showRejected">
                                                                    {{ showRejected ? 'Masquer' : 'Voir le détail' }}
                                                                </v-btn>
                                                            </div>

                                                            <v-simple-table v-if="showRejected && amountsPreview.errors.length"
                                                                            class="mt-3"
                                                                            dense
                                                                            style="border: 1px solid #eaeaea">
                                                                <template v-slot:default>
                                                                    <thead>
                                                                    <tr>
                                                                        <th>Ligne</th>
                                                                        <th>Numéro</th>
                                                                        <th>Raison</th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    <tr v-for="(error,i) in amountsPreview.errors"
                                                                        :key="i">
                                                                        <td>{{ error.line }}</td>
                                                                        <td>{{ error.phone }}</td>
                                                                        <td>{{ error.reason }}</td>
                                                                    </tr>
                                                                    </tbody>
                                                                </template>
                                                            </v-simple-table>

                                                        </v-card-text>
                                                    </v-card>

                                                </div>

                                                <v-radio-group v-model="form.type" label="Type des SMS *">
                                                    <v-radio
                                                            v-for="(type,i) in types"
                                                            :key="i"
                                                            :label="type.name"
                                                            :value="type.value"
                                                    ></v-radio>
                                                </v-radio-group>
                                            </v-card-text>

                                            <v-card-actions>
                                                <v-spacer/>
                                                <v-btn color="primary" text @click="step = 1">
                                                    <v-icon left>mdi-arrow-left</v-icon>
                                                    Retour
                                                </v-btn>
                                                <v-btn :dark="canContinueStep2"
                                                       :disabled="!canContinueStep2"
                                                       color="primary"
                                                       depressed
                                                       @click="step = 3">
                                                    Continuer
                                                    <v-icon right>mdi-arrow-right</v-icon>
                                                </v-btn>
                                            </v-card-actions>

                                        </v-card>
                                    </v-stepper-content>

                                    <v-stepper-content step="3">
                                        <v-card>

                                            <v-card-text>

                                                <v-alert border="left"
                                                         dense
                                                         prominent
                                                         text
                                                         type="info">
                                                                            <span class="font-weight-bold pointer">
                                                                              <Copy text="@person"/>
                                                                            </span>
                                                    Est remplacé par le nom de la personne
                                                </v-alert>

                                                <v-textarea v-model.trim="form.sms"
                                                            :error-messages="errors.sms"
                                                            class="sms"
                                                            clearable
                                                            counter
                                                            label="Écrivez un SMS ici *"
                                                            outlined
                                                            prepend-inner-icon="mdi-cellphone-message"
                                                            rows="3"></v-textarea>
                                            </v-card-text>

                                            <v-card-actions>
                                                <v-spacer/>
                                                <v-btn color="primary" text @click="step = 2">
                                                    <v-icon left>mdi-arrow-left</v-icon>
                                                    Retour
                                                </v-btn>
                                                <v-btn :dark="!(!form.sms || !form.message)"
                                                       :disabled="!form.sms || !form.message"
                                                       color="primary"
                                                       depressed
                                                       @click="checkCost">
                                                    <v-icon left>mdi-send</v-icon>
                                                    Envoyer
                                                </v-btn>
                                            </v-card-actions>

                                        </v-card>
                                    </v-stepper-content>

                                </v-stepper-items>
                            </v-stepper>

                        </v-card>
                    </v-col>
                </v-row>
            </div>


            <v-dialog v-model="dialog"
                      persistent
                      scrollable
                      width="500">
                <v-card :disabled="isLoading || costLoading"
                        :loading="isLoading || costLoading">

                    <v-card-title>
                        <v-spacer/>
                        <v-icon @click="dialog = false">mdi-close</v-icon>
                    </v-card-title>

                    <v-card-text v-if="costLoading">
                        <v-skeleton-loader type="avatar,article,article"/>
                    </v-card-text>

                    <v-card-text v-else class="text-center">

                        <v-avatar color="gifty" size="80">
                            <v-icon dark size="40">mdi-information</v-icon>
                        </v-avatar>

                        <h2 class="py-5">CONFIRMATION</h2>

                        <p>
                            <span class="font-weight-medium">Transferts :</span>
                            {{ analytic.recipients_count }}
                        </p>

                        <p>
                            <span class="font-weight-medium">Total SMS :</span>
                            {{ analytic.total_sms }}
                        </p>

                        <p>
                            <span class="font-weight-medium">Coût total des SMS :</span>
                            {{ CurrencyFormatting(analytic.cost_sms) }} DZD
                        </p>

                        <p>
                            <span class="font-weight-medium">Total solde à envoyer :</span>
                            {{ CurrencyFormatting(analytic.amount_total) }} DZD
                        </p>

                        <p>
                            <span class="font-weight-medium">Coût total de l’operation :</span>
                            {{ CurrencyFormatting(analytic.amount_total + analytic.cost_sms) }} DZD
                        </p>

                        <p class="primary--text font-weight-medium">
                            <span>Votre solde actuel :</span>
                            {{ CurrencyFormatting(analytic.balance) }} DZD
                        </p>

                        <p class="info--text font-weight-medium">
                            <span>Solde restant aprés l’opération :</span>
                            {{ CurrencyFormatting(remainingBalance()) }} DZD
                        </p>

                        <v-alert v-if="remainingBalance() < 0"
                                 prominent
                                 text
                                 type="info">
                            Vous ne pouvez pas créer cette campagne car son solde total dépasse votre solde actuel.
                        </v-alert>

                    </v-card-text>

                    <v-card-actions v-if="!costLoading">
                        <v-spacer/>
                        <v-btn color="gifty" text @click="dialog=false">
                            Fermer
                        </v-btn>

                        <v-btn :dark="remainingBalance()>=0"
                               :disabled="remainingBalance() < 0"
                               :loading="isLoading"
                               color="gifty"
                               depressed
                               @click="save">
                            Valider
                            <v-icon right>mdi-check</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-container>
    </div>
</template>

<script>
import {HTTP} from "@/http-common";
import moment from 'moment'

export default {
    data() {
        return {
            id: null,
            duplicateLoading: false,
            step: 1,
            isDBLoading: false,
            isLoading: false,
            dateMenu: false,
            timeMenu: false,
            form: {
                title: null,
                amount: null,
                amount_mode: 'fixed',
                amounts_file: null,
                type: 'all',
                sms: "Bonjour @person, bienvenue sur l'application GIFTY",
                message: 'Bonjour @person, bienvenue sur l\'application GIFTY',
                image: null,
                youtube_link: null,
                database_id: null,
                scheduled_date: moment().format('YYYY-MM-DD'),
                scheduled_time: moment().add(10, 'minutes').format('HH:mm'),
            },
            errors: {},
            databases: [],
            dialog: false,
            costLoading: false,
            analytic: {
                total_sms: 0,
                cost_sms: 0,
                amount_total: 0,
                recipients_count: 0,
                balance: 0
            },

            fileUrl: process.env.VUE_APP_FILE_URL,
            fileLoading: false,
            fileErrors: [],

            amountsLoading: false,
            amountsPreview: null,
            showRejected: false,
        };
    },
    methods: {
        save() {
            this.isLoading = true
            let data = this.form
            data['scheduled_datetime'] = this.form.scheduled_date + ' ' + this.form.scheduled_time + ':00'

            if (this.form.amount_mode === 'file') {
                data['amount'] = null
            } else {
                data['amounts_file'] = null
            }

            HTTP.post('/v1/campaigns/store', data).then(() => {
                this.isLoading = false
                this.$successMessage = "Données de campagne enregistrées avec succès"
                this.$store.commit('setUserBalance', this.remainingBalance())
                this.$router.push('/campaigns')
            }).catch(err => {
                this.isLoading = false
                this.dialog = false
                this.errors = err.response.data.errors
                this.$errorMessage = "Une erreur s'est produite veuillez corriger."
                this.$vuetify.goTo(0)
                console.log(err)
            })
        },
        getDatabases() {
            this.isDBLoading = true
            HTTP.get('/v1/users/databases').then(res => {
                this.isDBLoading = false
                this.databases = res.data.data
            }).catch(err => {
                this.isDBLoading = false
                console.log(err)
            })
        },
        checkCost() {
            this.dialog = true
            this.costLoading = true
            HTTP.get('/v1/campaigns/check-cost', {
                params: {
                    database_id: this.form.database_id,
                    type: this.form.type,
                    amount_mode: this.form.amount_mode,
                    amount: this.form.amount_mode === 'fixed' ? this.form.amount : null,
                    amounts_file: this.form.amount_mode === 'file' ? this.form.amounts_file : null,
                    sms: this.form.sms,
                }
            }).then(res => {
                this.costLoading = false
                this.analytic = res.data.data
            }).catch(err => {
                this.isDBLoading = false
                this.dialog = false
                this.errors = err.response.data.errors
                this.$errorMessage = "Une erreur s'est produite veuillez corriger."
                this.$vuetify.goTo(0)
                console.log(err)
            })
        },
        handleUploadFile(file) {
            if (file) {
                this.fileLoading = true
                let formData = new FormData()
                formData.append('image', file)
                HTTP.post('/v1/campaigns/upload', formData).then((res) => {
                    this.form.image = res.data
                    this.fileLoading = false
                }).catch((err) => {
                    this.fileErrors = err.response.data.errors
                    this.$errorMessage = "Une erreur s'est produite veuillez corriger."
                    this.fileLoading = false
                    console.log(err)
                })
            }
        },
        resetImage() {
            this.form.image = null
            this.$refs.image.reset()
        },
        handleUploadAmounts(file) {
            if (!file) {
                return
            }

            this.amountsLoading = true
            this.showRejected = false
            this.errors.amounts_file = null

            let formData = new FormData()
            formData.append('file', file)
            formData.append('database_id', this.form.database_id)

            HTTP.post('/v1/campaigns/import-amounts', formData).then(res => {
                this.amountsLoading = false
                let data = res.data.data
                this.form.amounts_file = data.amounts_file
                this.amountsPreview = data

                if (!data.summary.recipients_count) {
                    this.form.amounts_file = null
                    this.$errorMessage = "Aucun numéro du fichier ne correspond à un point de vente de cette base."
                }
            }).catch(err => {
                this.amountsLoading = false
                this.resetAmountsFile()
                if (err.response && err.response.data.errors) {
                    this.errors = err.response.data.errors
                }
                this.$errorMessage = "Le fichier n'a pas pu être lu, vérifiez son format."
                console.log(err)
            })
        },
        previewExistingAmounts() {
            this.amountsLoading = true

            let formData = new FormData()
            formData.append('amounts_file', this.form.amounts_file)
            formData.append('database_id', this.form.database_id)

            HTTP.post('/v1/campaigns/import-amounts', formData).then(res => {
                this.amountsLoading = false
                this.amountsPreview = res.data.data
            }).catch(err => {
                this.amountsLoading = false
                this.resetAmountsFile()
                this.$errorMessage = "Le fichier des montants n'est plus disponible, importez-le à nouveau."
                console.log(err)
            })
        },
        resetAmountsFile() {
            this.form.amounts_file = null
            this.amountsPreview = null
            this.showRejected = false
            if (this.$refs.amountsFile) {
                this.$refs.amountsFile.reset()
            }
        },
        downloadTemplate() {
            let content = "telephone;montant\n0551234567;1000\n0661112233;2500\n"
            let blob = new Blob(["\ufeff" + content], {type: 'text/csv;charset=utf-8;'})
            let link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'modele-montants.csv'
            link.click()
            URL.revokeObjectURL(link.href)
        },
        remainingBalance() {
            return this.analytic.balance - (this.analytic.amount_total + this.analytic.cost_sms)
        },
        getCampaignById() {
            this.duplicateLoading = true
            HTTP.get('/v1/campaigns/' + this.id + '/show').then(res => {
                this.duplicateLoading = false
                if (res.data.data) {
                    let data = res.data.data
                    this.form = {
                        title: data.title,
                        amount: data.amount,
                        amount_mode: data.amount_mode || 'fixed',
                        amounts_file: data.amounts_file,
                        type: data.type,
                        sms: data.sms,
                        message: data.message,
                        image: data.image,
                        youtube_link: data.youtube_link,
                        database_id: data.database_id,
                        scheduled_date: moment().format('YYYY-MM-DD'),
                        scheduled_time: moment().add(10, 'minutes').format('HH:mm'),
                    }

                    if (this.form.amount_mode === 'file' && this.form.amounts_file) {
                        this.previewExistingAmounts()
                    }
                } else {
                    this.$router.push('/404')
                }
            }).catch(err => {
                this.duplicateLoading = false
                console.log(err)
            })
        }
    },
    created() {
        this.getDatabases()
        if (this.$route.params.id) {
            this.id = this.$route.params.id
            this.getCampaignById()
        }
    },
    watch: {
        'form.database_id': function (value, oldValue) {
            // the file is matched against the salepoints of one database
            if (oldValue && value !== oldValue) {
                this.resetAmountsFile()
            }
        },
        'form.amount_mode': function () {
            this.errors = {}
        },
    },
    computed: {
        canContinueStep2() {
            if (!this.form.database_id) {
                return false
            }

            return this.form.amount_mode === 'file'
                    ? !!this.form.amounts_file && !this.amountsLoading
                    : !!this.form.amount
        },
        types() {
            return [
                {name: 'Envoyer a tous le monde', value: 'all'},
                {name: 'Envoyer seulement au person qui non pas de compte GIFTY', value: 'gifty'},
            ]
        }
    }
};
</script>

<style>
.sms .v-counter {
    background-color: #ffab02;
    padding: 5px;
    border-radius: 5px;
    color: #fff !important;
}

</style>